import { FeatureName } from "@accurx/auth";

export { AppointmentsManualUploadRoutes } from "./Routes";

export const AppointmentsManualUploadFeatureFlags = [
    FeatureName.BulkAppointmentImportModuleEnabled,
];
